import { useState } from 'preact/hooks';

interface SwitcherOptions {
  casesCount: number;
  getInitCase: () => number;
}

interface SwitcherResult {
  switchCase: number;
  nextCase: () => void;
}

export default function useSwitcher({ casesCount, getInitCase }: SwitcherOptions): SwitcherResult {
  const [switchCase, setSwitchCase] = useState(getInitCase);
  function nextCase() {
    setSwitchCase((switchCase + 1) % casesCount);
  }
  return { switchCase, nextCase };
}
